var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-dropdown", {
    attrs: {
      trigger: ["click"]
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c("div", {
    attrs: {
      slot: "overlay"
    },
    slot: "overlay"
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.loading
    }
  }, [_c("div", {
    staticClass: "dropdown-tabs",
    style: {
      width: "180px"
    }
  }, [_c("div", {
    staticStyle: {
      width: "100%",
      "border-top": "1px solid #f0f0f0"
    }
  }), _c("div", {
    staticStyle: {
      padding: "6px 12px 12px"
    }
  }, [_c("div", {
    staticStyle: {
      color: "#bfbfbf",
      "font-size": "12px",
      "line-height": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.dyx")))]), _c("RouterLink", {
    staticClass: "label",
    attrs: {
      to: {
        path: "/customermanager/customerlist",
        query: {
          approvalResult: 1
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("header.newCount")) + " "), _c("a-badge", {
    attrs: {
      count: _vm.data.newCustomerNum
    }
  })], 1)], 1)])])], 1), _c("span", {
    staticClass: "header-notice",
    on: {
      click: _vm.fetchNotice
    }
  }, [_c("a-badge", {
    staticClass: "notice-badge",
    attrs: {
      count: _vm.data.newProductNum + _vm.data.newCustomerNum
    }
  }, [_c("a-icon", {
    class: ["header-notice-icon"],
    attrs: {
      type: "bell"
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };